/**
 * =============================================================================
 * blog.js
 * =============================================================================
 * Blog page functionality
 * =============================================================================
 */

var Blog = {
  container: undefined,
  sectionId: undefined, // ID of the blog page section, so we know what section to request via fetch

  /**
   * Initialisation
   */
  init: function() {
    this.container = document.getElementById("blog-container");
    if(!this.container){
      return;
    }
    this.sectionId = this.container.dataset.sectionId;

    this.setupEventListeners();

    window.addEventListener('popstate', this.onHistoryChange.bind(this));
  },

  /**
   * Setup event listeners
   */
  setupEventListeners: function() {
    let filterButtons = this.container.querySelectorAll(".filter");
    filterButtons.forEach(filterButton => {
      filterButton.addEventListener("click", this.onLoadMoreClick.bind(this));
    });
  },

  /**
   * Reload the page if the user clicks 'back' in the browser
   * @param {PopStateEvent} event 
   */
  onHistoryChange: function(event) {
    this.renderPage(window.location.href, event, false);
  },

  /**
   * Render the section
   * @param {String} url The URL to load (tag filters)
   * @param {Event} event The original trigger event
   * @param {Boolean} updateURL Whether to update the URL with the new URL
   */
  renderPage: function(url, event, updateURL = true) {
    document.getElementById('results-loading').classList.remove('d-none');
    const sectionedUrl = `${url}?section_id=${this.sectionId}`;
    this.renderSectionFromFetch(sectionedUrl, event);

    if (updateURL) {
      this.updateURL(url);
    }
  },

  /**
   * Fetch the section and re-render
   * @param {String} url URL to fetch and render 
   */
  renderSectionFromFetch: function(url) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        let parsedHtml = new DOMParser().parseFromString(html, 'text/html');
        document.getElementById("blog-container").innerHTML = parsedHtml.getElementById("blog-container").innerHTML;
        this.setupEventListeners();
        document.getElementById('results-loading').classList.add('d-none');
        mp_lazyload_setup();
      });
  },

  /**
   * Start the process of loading in new product tiles
   * @param {Event} event The initiating event
   */
  onLoadMoreClick: function(event) {
    event.preventDefault();
    this.renderPage(event.currentTarget.href);
  },

  /**
   * Update the URL hash with new parameters
   * @param {String} url 
   */
  updateURL: function(url) {
    history.pushState({}, '', url);
  }
}

export default Blog;